 <template>
  <div>
    <section>
    <div class="bg-white">
		 <treeselect
		  ref="treeselectRef"
		  v-model="chooseValues"
		  @select="onSelect"
		  @close="onClose"
		  @search-change="onSearchChange"
		  @keydown.native="onKeydown"
		  @paste.native="onPaste"
		  @deselect="ondeSelect"
		  :backspaceRemoves="true"
		  :multiple="this.multiple"
		  :required="false"
		  :maxHeight="500"
		  :limit="displayedLimit"
		  :show-count="true"
      :searchable="true"
		  :clearable="false"
      :limitText="getLimitText"
		  :placeholder="(fromOrder) ? $t('lang.search.criteria'): $t('lang.search.insertsearch')"
		  :alwaysOpen="alwaysopen"
		  :defaultExpandLevel="0"
		  :openDirection="openDirection"
		  :append-to-body="true"
      :load-options="searchOptions"
	  :async="true"
	  :defaultOptions="defaulOptions"
	  :disabled="isDisabled"
	  :flatten-search-results="flattenSearchResults" >
          <label v-if="node.id != ''" slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
            {{ node.label }}
          </label>
          <small v-else slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" class="text-secondary">
            {{ node.label }}
          </small>
        </treeselect>

     </div>
	<div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
		<i 
		v-if="hasValuesToCopy && hasPermissions('superAdmin') && this.$route.fullPath.includes('/orders/')"
		class="icon icon-clipboard cursor-pointer"
		:title="$t('lang.general.copytoclipboard')"
		@click="copyContent()"></i>
		<span v-else></span>
		<button
			v-if="showSeeMoreButton && selectedCount > 40 && !expanded"
			type="button"
			class="btn btn-primary btn-sm p-0"
			@click="expanded = true"
		>
			{{ $t('lang.notification.seemore') }}
		</button>
		<button
			v-if="showSeeMoreButton && selectedCount > 40 && expanded"
			type="button"
			class="btn btn-danger btn-sm p-0"
			@click="expanded = false"
		>
			{{ $t('lang.notification.hide') }}
		</button>
	</div>

    </section>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 20)
}

export default {
    props: {
        fromOrder: {
	        type: Boolean,
	        required: false,
	        default: false,
      	},
        default_values: {
	        type: [Array, String, Number, Object],
	        required: false,
	        default: () => [],
      	},
        option_list: {
	        type: Array,
	        required: true,
	        default: () => [],
      	},
        alwaysopen: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
        multiple: {
	        type: Boolean,
	        required: false,
	        default: () => true,
      	},
        emptyOption: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
		isDisabled: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
		openDirection: {
	        type: String,
	        required: false,
	        default: () => 'auto',
      	},
	flattenSearchResults: {
	        type: Boolean,
	        required: false,
	        default: () => false,
      	},
		showSeeMoreButton: {
			type: Boolean,
			required: false,
			default: false,
		},
		/** When true: type + Enter matches tree and selects; paste "a, b, c" splits by comma and selects matches. No draft for non-matches (text is cleared). */
		allowTypeAndSelect: {
			type: Boolean,
			required: false,
			default: false,
		},
    },
    data() {
      return {
      	chooseValues: [],
      	defaulOptions: [],
		expanded: false,
		localValues: [],
		lastSearchQuery: '',
       };
    },
    watch: {
		default_values: {
			handler(val) {
				this.localValues = this.normalizeToArray(val);
				this.chooseValues = [...this.localValues];
			},
			immediate: false,
			deep: true,
		},
		option_list: {
			handler(list) {
				this.defaulOptions = [];
				if (this.emptyOption) {
					this.defaulOptions.push({ label: '<Nothing selected>', id: '' });
				}
				(list || []).forEach((val) => this.defaulOptions.push(val));
			},
			immediate: false,
			deep: true,
		},
    },
    created(){
    	let obj;
	    this.defaulOptions = [];
    	if(this.emptyOption){
	      obj = {};
	      obj.label = '<Nothing selected>';
	      obj.id = '';
	      this.defaulOptions.push(obj);
    	}

        this.option_list.forEach((val) => {
        	this.defaulOptions.push(val);
        });

		this.localValues = this.normalizeToArray(this.default_values);
    	this.chooseValues = [...this.localValues];
    },

    components: {
    	'treeselect': Treeselect,
    },
	computed: {
		defaultValuesArray() {
			return Array.isArray(this.localValues) ? this.localValues : [];
		},
		hasValuesToCopy() {
			return this.defaultValuesArray.length > 0;
		},
		selectedCount() {
			return this.defaultValuesArray.length;
		},
		displayedLimit() {
			if (this.showSeeMoreButton && this.expanded && this.selectedCount > 40) {
				return this.selectedCount;
			}
			return 40;
		},
	},
    methods: {
		normalizeToArray(val) {
			if (val == null || val === '') return [];
			if (Array.isArray(val)) {
				return val.map((v) => (typeof v === 'object' && v != null && 'id' in v ? v.id : v));
			}
			if (typeof val === 'string' || typeof val === 'number') return [val];
			if (typeof val === 'object' && 'id' in val) return [val.id];
			return [];
		},
		hasPermissions(perm) {
			return this.$store.getters["authentication/hasPermissions"](perm);
		},
		/**
		 * Search tree (padre, hijo, nieto) for label match; only return ids of matching nietos (leaves).
		 * If "leisure" is in a parent label → not selected. If in a nieto label → selected.
		 */
		_findNodeIdsByLabelMatch(tree, query) {
			if (!tree || !Array.isArray(tree) || !query || !String(query).trim()) return [];
			const q = String(query).trim().toLowerCase();
			const ids = [];
			const visit = (nodes) => {
				if (!nodes || !Array.isArray(nodes)) return;
				for (const node of nodes) {
					if (node == null || node.id === undefined || node.id === '') continue;
					const hasChildren = node.children && node.children.length > 0;
					const labelMatches = node.label != null && String(node.label).toLowerCase().includes(q);
					if (hasChildren) {
						visit(node.children);
					} else if (labelMatches) {
						ids.push(node.id);
					}
				}
			};
			visit(tree);
			return ids;
		},
		/** Apply matched ids to selection (merge, no duplicates) and clear search. */
		_applyMatchedIdsAndClear(matchedIds) {
			const newValues = [...new Set([...this.localValues, ...matchedIds])];
			this.localValues = newValues;
			this.chooseValues = [...newValues];
			this.$emit('input', newValues);
			this.lastSearchQuery = '';
			this.$nextTick(() => {
				const treeselect = this.$refs.treeselectRef;
				if (treeselect && typeof treeselect.closeMenu === 'function') treeselect.closeMenu();
			});
		},
		onSearchChange(query) {
			if (this.allowTypeAndSelect) this.lastSearchQuery = query || '';
		},
		onKeydown(evt) {
			if (!this.allowTypeAndSelect) return;
			const q = (this.lastSearchQuery || '').trim();
			if (evt.key !== 'Enter' || !q) return;
			evt.preventDefault();
			evt.stopPropagation();
			const matchedIds = this._findNodeIdsByLabelMatch(this.option_list, q);
			this._applyMatchedIdsAndClear(matchedIds);
		},
		onPaste(evt) {
			if (!this.allowTypeAndSelect) return;
			evt.preventDefault();
			evt.stopPropagation();
			const text = evt.clipboardData ? evt.clipboardData.getData('text/plain') : '';
			if (!text || !String(text).trim()) return;
			const tokens = String(text).split(',').map(s => s.trim()).filter(Boolean);
			const matchedIds = [];
			for (const token of tokens) {
				matchedIds.push(...this._findNodeIdsByLabelMatch(this.option_list, token));
			}
			this._applyMatchedIdsAndClear(matchedIds);
		},
		/** En modo jerárquico: busca un nodo por id en el árbol. */
		_findNodeById(nodes, id) {
			if (!nodes || !Array.isArray(nodes)) return null;
			for (let i = 0; i < nodes.length; i++) {
				if (nodes[i].id === id) return nodes[i];
				const found = this._findNodeById(nodes[i].children, id);
				if (found) return found;
			}
			return null;
		},
		/** En modo jerárquico: de un nodo, recoge los labels de todos los nietos (hojas). */
		_collectLeafLabelsFromNode(node) {
			if (!node) return [];
			if (node.children && node.children.length > 0) {
				return node.children.reduce((acc, child) => acc.concat(this._collectLeafLabelsFromNode(child)), []);
			}
			if (node.label != null) return [node.label];
			return [];
		},
		/** En modo jerárquico: dados selectedIds (branch o leaf), devuelve los labels de todos los nietos elegidos. */
		_getLeafLabelsFromSelection(tree, selectedIds) {
			if (!tree || !Array.isArray(tree) || !selectedIds || !selectedIds.length) return [];
			const result = [];
			for (let i = 0; i < selectedIds.length; i++) {
				const id = selectedIds[i];
				if (id == null || id === '') continue;
				const idStr = String(id);
				const node = this._findNodeById(tree, idStr);
				if (!node) continue;
				if (idStr.indexOf('branch-') === 0) {
					result.push(...this._collectLeafLabelsFromNode(node));
				} else {
					if (node.label != null) result.push(node.label);
				}
			}
			return [...new Set(result)];
		},
		copyContent(){
			try {
				const options = Array.isArray(this.option_list) ? this.option_list : [];
				const selectedIds = this.defaultValuesArray;

				if (selectedIds.length === 0) {
					console.warn("No hay valores seleccionados.");
					return;
				}

				const isHierarchical = options.some(opt => opt.children && Array.isArray(opt.children) && opt.children.length > 0);
				let selectedLabels;

				if (isHierarchical) {
					selectedLabels = this._getLeafLabelsFromSelection(options, selectedIds);
				} else {
					selectedLabels = options
						.filter(opt => selectedIds.includes(opt.id))
						.map(opt => opt.label)
						.filter(Boolean);
				}

				if (selectedLabels.length === 0) {
					console.log("No se encontraron etiquetas para copiar.");
					return;
				}

				const textToCopy = selectedLabels.join(", ");

				// Copiar al portapapeles (moderno)
				navigator.clipboard.writeText(textToCopy)
				.then(() => {
					console.log("Etiquetas copiadas al portapapeles ✅");
				})
				.catch(() => {
					// fallback para navegadores viejos
					const textarea = document.createElement("textarea");
					textarea.value = textToCopy;
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand("copy");
					document.body.removeChild(textarea);
					console.log("Etiquetas copiadas al portapapeles ✅ (fallback)");
				});
			} catch (error) {
				console.error("Error al copiar etiquetas:", error);
			}
		},
		getLimitText(count){
			return "Recherchez ( "+count+" sélectionnés )";
		},
		getChildren(options){
		  const children = options.map(function(item) {
		    return item.children;
		  });
		  return children.flat();
		},
	    searchOptions({ action, searchQuery, callback }) {
	      if (action === ASYNC_SEARCH) {
	        simulateAsyncOperation(() => {
	          let options = this.defaulOptions.filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	          if(options.length == 0){
	            let options = this.getChildren(this.defaulOptions).filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	            if(options.length == 0){
	              let options = this.getChildren(this.getChildren(this.defaulOptions)).filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
	              callback(null, options);
	            }
	            callback(null, options);
	          }
	          callback(null, options)
	        })
	      }
	    },
	    onSelect(node, instanceId){
	    	const arr = this.localValues;
	    	if(!this.multiple){
	    		arr.splice(0, arr.length);
	    		this.$emit('deleted', node);
	    	}
	      	arr.push(node.id);

	    	if(!this.multiple && this.emptyOption && node.id == ''){
	    		arr.splice(0, 1);
	    		this.$emit('deleted', node);
	    	}

			this.chooseValues = [...arr];
			this.$emit('input', arr);
			this.$emit('selected', node);
	    },
		onClose(node, instanceId){
			if(Array.isArray(node) && node.length !== this.localValues.length){
				const ids = node.map((n) => (n && (n.id !== undefined ? n.id : n)));
				this.localValues.length = 0;
				this.localValues.push(...ids);
				this.chooseValues = [...this.localValues];
				this.$emit('input', [...this.localValues]);
			}
			this.$emit('closed', node);
	    },
	    ondeSelect(node, instanceId){
	    	const arr = this.localValues;
	    	const index = arr.indexOf(node.id);
			if (index !== -1) arr.splice(index, 1);
			this.chooseValues = [...arr];
			this.$emit('input', [...arr]);
			this.$emit('deleted', node);
	    },
    }
}

</script>


<style>
.vue-treeselect__multi-value-item-container.vue-treeselect__multi-value-item--transition-enter-to{
   color: white;
    font-weight: bold;

}
.vue-treeselect__multi-value-item{
	border-radius:3px;
	font-size: 10px;
	background-color: #5055ea;
    color: white;
}

.vue-treeselect__icon.vue-treeselect__value-remove{
    border-left: 0;
    color: white;
}
</style>
